import { generateUrlParams } from "../../utils/generateUrlParams";

const baseUrl = "Department";

export const getDepartmentsUrl = (studentTypeId, facultyId) =>
	`${baseUrl}/${studentTypeId}${
		facultyId ? `/${facultyId}` : ""
	}/departments`;
export const getAllDepartmentsUrl = () => `${baseUrl}/departments`;
export const getDepartmentOptionUrl = ({ departmentId }) =>
	`${baseUrl}/${departmentId}/departmentoptions`;
export const getAllHODsUrl = (filter) =>
	`${baseUrl}/hods?${generateUrlParams(filter)}`;
export const assignHODToDepartmentUrl = () =>
	`${baseUrl}/assign-hod-to-department`;
export const jupebCourseOptionsUrl = () => `${baseUrl}/jupeb-options`;
export const jupebCourseOptionsSubjectUrl = (jupebOptionsId) =>
	`${baseUrl}/${jupebOptionsId}/jupeb-options-subjects`;
export const getLecturerDepartmentsUrl = () =>
	`${baseUrl}/departments-for-result-approval`;

export const getAllDepartmentsWithoutValuesUrl = () => `${baseUrl}/departments`;

export const assignDepartmentProgramme = () =>
	`${baseUrl}/assign-department-programme`;
export const bulkDepartmentsUploadUrl = () => `${baseUrl}/upload-departments`;
export const bulkOptionsUploadUrl = () => `${baseUrl}/upload-options`;
export const createDepartmentUrl = () => `${baseUrl}/create-department`;
export const createOptionUrl = () => `${baseUrl}/create-option`;
export const deleteDepartmentUrl = (id) =>
	`${baseUrl}/delete-department?departmentId=${id}`;
export const deleteOptionUrl = (id) =>
	`${baseUrl}/delete-department-option?optionId=${id}`;
export const downloadDepartmentExcelTemplateUrl = () =>
	`${baseUrl}/download-department-upload-template`;
export const downloadOptionExcelTemplateUrl = () =>
	`${baseUrl}/download-department-options-upload-template`;
export const getAllPaginatedDepartmentsUrl = (filter) =>
	`${baseUrl}/get-paginated-departments?${generateUrlParams(filter)}`;
export const getAllPaginatedOptionsUrl = (filter) =>
	`${baseUrl}/get-paginated-departments-options?${generateUrlParams(filter)}`;
export const getProgrammeDepartmentsUrl = (programId) =>
	`${baseUrl}/get-programme-departments?programId=${programId}`;
export const toggleDepartmentActivationStatusUrl = (id) =>
	`${baseUrl}/toggle-department-activation?departmentId=${id}`;
export const updateOptionUrl = () => `${baseUrl}/update-department-option`;
export const updateDepartmentUrl = () => `${baseUrl}/update-department`;
export const toggleOptionActivationStatusUrl = (id) =>
	`${baseUrl}/toggle-option-activation?optionId=${id}`;
